import React from 'react';
import PropTypes from 'prop-types';

const attributesByCountry = new Map([
  [
    'United States',
    {
      type: 'text', // let zip start with 0
      inputMode: 'numeric', // force numeric keyboard
      minLength: '5',
      maxLength: '5',
    },
  ],
]);

const InputZip = ({ country, setRef, ...props }) => (
  <input {...props} {...attributesByCountry.get(country)} ref={setRef} />
);

InputZip.propTypes = {
  country: PropTypes.string,
  setRef: PropTypes.func,
};
InputZip.defaultProps = {
  country: undefined,
  setRef: undefined,
};

export default InputZip;



// WEBPACK FOOTER //
// ./src/app/components/InputZip.jsx